// HospitalPage.js
import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import StickyHeader from "../../components/StickyHeader";
import StickyFooter from "../../components/StickyFooter";
import "../../css/news.css";
import { useNavigate } from 'react-router-dom'; 
function EnergyManageSystem() {
    const navigate = useNavigate();
  useEffect(() => {
    AOS.init({
      duration: 800, // 缩短动画时间使响应更快
      once: false, // 允许重复触发动画
      offset: 100,
      easing: "ease-out-cubic", // 添加缓动效果
      delay: 0,
      mirror: true, // 页面滚动时反向动画
    });
  }, []);
  const handleNewsClick = () => {
    navigate(`/company/news/dedails`); 
  };
  const handleNewsClicks = () => {
    navigate(`/company/news/dedailp`); 
  };
  return (
    <div className="home-container">
      <StickyHeader />
      <div className="main-content">
        <div
          className='stitle'
        >
          <img
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            src={`${process.env.PUBLIC_URL}/imgs/newsbg.png`}
            alt=""
          />
          <div className="top-title-emsy">新闻资讯</div>
          <div className="top-title-ems-2y">
          紧跟热点新闻，掌握最新技术！欢迎了解企业更多动态！获取企业更多资讯！
          </div>
        </div>
        <div style={{ minHeight: "800px" }}>
          {/* 第一个盒子 - 产 品 介 绍 */}
          <div className="top00 animated-section">
            <Container>
              <div className="box">
                <div className="top">
                  <div className="noe1" data-aos="fade-down">
                    <span className="h1">新 闻 资 讯</span>
                    <p>
                      <img
                        src={`${process.env.PUBLIC_URL}/imgs/Dot.png`}
                        alt=""
                        className="dot-animation"
                      />
                    </p>
                  </div>
                  <div className="boxnoply">
                    <div
                      className="rit"
                      data-aos="fade-right"
                      data-aos-delay="200"
                      onClick={() => handleNewsClick()}

                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/imgs/new1.png`}
                        alt=""
                        className="image-hoverls"
                      />
                      <div style={{  height: "20%" }}>
                      <p className="texttile">
                      桐城市慈善会各级领导莅临指导
                      </p>
                      <p className="textps">
                      2025-07-23
                      </p>
                      </div>
                    </div>
                    <div
                      className="rit"
                      data-aos="fade-right"
                      data-aos-delay="200"
                      onClick={() => handleNewsClicks()}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/imgs/new2.png`}
                        alt=""
                        className="image-hoverls"
                      />
                      <div style={{  height: "20%" }}>
                      <p className="texttile">
                      桐城市工商联各级领导莅临指导
                      </p>
                      <p className="textps">
                      2025-07-23
                      </p>
                      </div>
                    </div>
                  
                  </div>
                </div>
              </div>
            </Container>
          </div>

         

        
          
        </div>
      </div>

      <StickyFooter />
    </div>
  );
}

export default EnergyManageSystem;
